<!--
 * @Author: 'chenrongda' '861191244@qq.com'
 * @Date: 2025-02-25 10:48:34
 * @LastEditors: 'chenrongda' '861191244@qq.com'
 * @LastEditTime: 2025-11-18 17:51:08
 * @FilePath: \official.site\src\views\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <img src="../assets/shj.datang.png" alt="">
    <div class="ws_SX"><img src="../assets/ws_SX.png" alt=""></div>
    <img src="../assets/conWarp.png" alt="">
    <img src="../assets/shj_feature.png" alt="">
    <div class="clearfix">
      <img src="../assets/clearfix.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped lang='less'>
  img {
    vertical-align: top
  }

  .ws_SX {
    width: 100%;
    height: 700px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .clearfix {
    // background: pink;
    width: 1188px;
    margin: 0 auto;

    img {}
  }
</style>